'use client';

import { useEffect, useState } from 'react';

const pad = (n: number) => String(n).padStart(2, '0');

/**
 * Live HH:MM:SS clock for the footer status bar — ported 1:1 from the design's
 * `_tick()` loop. Renders empty on the server / first paint to avoid a hydration
 * mismatch, then starts ticking once mounted on the client.
 */
export function FooterClock() {
	const [clock, setClock] = useState('');

	useEffect(() => {
		const tick = () => {
			const d = new Date();
			setClock(
				`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`,
			);
		};
		tick();
		const id = setInterval(tick, 1000);
		return () => clearInterval(id);
	}, []);

	return <span suppressHydrationWarning>{clock}</span>;
}
